import { IAddress } from "../Address/Address";
import { IBaseModel } from "../BaseModel";

export enum CustomerStatus {
  Archived,
  Disabled,
  Enabled,
}

export interface ICustomerAddress
  extends Omit<IAddress, "name" | "longitude" | "latitude" | "formatted"> { }

export interface ICustomer extends IBaseModel, ICustomerAddress {
  status: CustomerStatus;
  name: string;
  usernamePrefix: string;
  domain: string;
  frontEndDomain: string;
  signingKey: string;
  vatNumber: string;
  email: string;
  contactName: string;
  smtpFrom: string;
  smtpFromName: string;
  telephone: string;

  // Virtuals
  brand: IBrand;
}

export interface IBrand extends IBaseModel {
  logo: string;
  widgetEmailDisplayLogo: string;
  croppedLogo: string;

  domain: string;
  primaryColour: string;
  secondaryColour: string;
}